"use strict";

angular.module("core").component("mainFooter", {
    templateUrl: require("./main-footer.component.html"),
    controller: function($scope, SUPPORT_PHONE_NUMBER) {
        $scope.supportPhoneNumber = SUPPORT_PHONE_NUMBER;
        $scope.currentYear = new Date().getFullYear();
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/footer/main-footer.component.js
// module id = 573
// module chunks = 0